import { render, staticRenderFns } from "./PdlDetail.vue?vue&type=template&id=e6bc770a"
import script from "./PdlDetail.vue?vue&type=script&lang=js"
export * from "./PdlDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports